/**
 * Created by akirilyuk on 02/5/2018
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        CP_CONST = require("connection-const"),
        LEResourceResolver = require("leResourceResolver"),
        ApiResources = require("assets/data/apiResources.json"),
        BaseCollection = require("collections/BaseCollection"),
        MessagingNotificationModel = require("connection-models/chatTab/MessagingNotificationModel"),
        MessagingNotificationCollection = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        MessagingNotificationCollection = BaseCollection.extend({
            resource: ApiResources.ConnectionPanel.MessagingNotifications,
            model: MessagingNotificationModel,
            initialize: function (models, options) {
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
                this._payload = [];
            },

            initConnection: function () {
                setInterval(_.bind(function () {
                    this.fetch({
                        data: this._payload,
                        type: 'POST',
                        add: true,
                        headers: {'Content-Type': 'application/json'}
                    });
                }, this), CP_CONST.MESSAGING_NOTIFICATIONS.FETCH_INTERVAL || 10000);
                this._payload = this.getRequestPayload();
                this.fetch({
                    data: this._payload,
                    type: 'POST',
                    add: true,
                    headers: {'Content-Type': 'application/json'}
                });
            },

            getRequestPayload: function () {
                var payload = [];
                this.models.forEach(function (model) {
                    payload.push({skillName: model.get('skillName'), sub: model.get('sub')});
                }, this);
                return payload;
            }
        });
    });

    return MessagingNotificationCollection;
});
